import React from "react";
import classes from "./DeleteUserModal.module.css";

export default function DeleteUserModal({ user, onCancel, onConfirm, loading }) {
  if (!user) return null;

  return (
    <div className={classes.backdrop} onClick={onCancel}>
      <div
        className={classes.modal}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <header className={classes.header}>
          <h3>Delete User</h3>
        </header>
        <div className={classes.body}>
          <p>
            Are you sure you want to delete <strong>{user.name || user.email}</strong>?
            This action cannot be undone and all associated data will be permanently removed.
          </p>
        </div>
        <footer className={classes.footer}>
          <button className={classes.secondaryBtn} onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button className={classes.dangerBtn} onClick={onConfirm} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </button>
        </footer>
      </div>
    </div>
  );
}

